import React, { useState } from "react";
import { useLanguage } from "../../hooks/useLanguageContext";
import { SUPPORTED_LANGUAGES, LANGUAGE_ORDER } from "../../config/languages";

/**
 * 언어 전환 버튼 컴포넌트
 */
export default function LanguageSwitcher() {
  const { currentLanguage, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (languageCode: string) => {
    setLanguage(languageCode as any);
    setIsOpen(false);
  };

  const currentLanguageInfo = SUPPORTED_LANGUAGES[currentLanguage];

  return (
    <div className="language-switcher">
      <button
        className={`language-switcher__button ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="언어 변경"
      >
        <img
          src="/assets/icons/Globe.svg"
          alt="globe"
          className="language-switcher__globe"
        />
        <span className="language-switcher__code">
          {currentLanguageInfo.code.toUpperCase()}
        </span>
        <img
          src="/assets/icons/CaretDown.svg"
          alt="dropdown"
          className={`language-switcher__caret ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="language-switcher__dropdown">
          {LANGUAGE_ORDER.map((languageCode) => {
            const languageInfo = SUPPORTED_LANGUAGES[languageCode];
            const isSelected = languageCode === currentLanguage;

            return (
              <button
                key={languageCode}
                className={`language-switcher__option ${isSelected ? "selected" : ""}`}
                onClick={() => handleLanguageChange(languageCode)}
                disabled={isSelected}
              >
                <span className="language-switcher__option-code">
                  {languageInfo.code.toUpperCase()}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
